// extracted by mini-css-extract-plugin
export default {"faqContent":"FAQContent_faqContent__VpK9h","description":"FAQContent_description__P2mUU","aboutUsButton":"FAQContent_aboutUsButton__nGb5p"};